<template>
  <div class="news-wrapper main">
            <breadCrumb></breadCrumb>
            <div class="subtitle course-subtitle">
                <h2 class="">优秀课程</h2>
            </div>
            <div class="course-list">
                <courseView :cloumn="4" :height="140"></courseView>
            </div>
        </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
    @import "../less/news_common.less";
    
    .news-course {
        background-color: #fff;
        min-height: 100vh;
        height: auto !important;
        height: 100vh; /*IE6不识别min-height*/
        position: relative;
        padding-bottom: 20px;
        box-sizing: border-box;

        .course-list {
            padding-top: 21px;
        }

        .footer-section {
            width: 100%;
            position: absolute;
            bottom: 0;
            overflow: hidden;
            max-height: 310px;
        }
    }
</style>